// src/admin/bars/AdminNavbar.tsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag, UserCircle, ChevronDown, ChevronUp } from 'lucide-react';
// CORRECTED: Path to AuthContext
import { useAuth } from '../../context/AuthContext'; // <--- CORRECTED PATH: THREE levels up

const AdminNavbar: React.FC = () => {
  // CORRECTED: Destructuring from useAuth should be { user, logout }
  const { user, logout } = useAuth(); // <--- CORRECTED: use `logout` from AuthContext
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {

    logout(); // <--- CORRECTED: Call the `logout` function from useAuth
    navigate("/");
    setDropdownOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-gradient-to-r from-yellow-700 to-amber-900 text-white p-4 flex justify-between items-center shadow-lg z-30">
      {/* Brand/Title */}
      <Link to="/admin/dashboard" className="flex items-center text-2xl font-bold">
        <ShoppingBag className="w-7 h-7 mr-3 text-yellow-300" />
        Sardar Jewellers
      </Link>

      {/* User Profile and Dropdown */}
      <div className="relative">
        <button
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center px-4 py-2 bg-yellow-600 rounded-lg hover:bg-yellow-700 transition duration-300 shadow-md text-sm focus:outline-none"
        >
          <UserCircle className="w-5 h-5 mr-2" />
          {user ? user.userName : 'Guest'} {/* Display user's name */}
          {dropdownOpen ? <ChevronUp className="w-4 h-4 ml-2" /> : <ChevronDown className="w-4 h-4 ml-2" />}
        </button>

        {dropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-xl z-40">
            <Link
              to="/admin/profile"
              className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
              onClick={() => setDropdownOpen(false)}
            >
              Manage Account
            </Link>
            <button
              onClick={handleLogout}
              className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default AdminNavbar;